"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const getBasket = ['organizationId', 'basketId', 'siteId', 'locale'];
const getPaymentMethodsForBasket = ['organizationId', 'basketId', 'siteId', 'locale'];
const getPriceBooksForBasket = ['organizationId', 'basketId', 'siteId'];
const getShippingMethodsForShipment = ['organizationId', 'basketId', 'shipmentId', 'siteId', 'locale'];
const getTaxesFromBasket = ['organizationId', 'basketId', 'siteId'];
var _default = exports.default = {
  getBasket,
  getPaymentMethodsForBasket,
  getPriceBooksForBasket,
  getShippingMethodsForShipment,
  getTaxesFromBasket
};